// 試合の乱数(mulberry32)。状態は world.rngState(32bitの整数)に持つので、worldを保存・復元すれば乱数の続きも戻る。
// 試合の計算(src/sim/)では Math.random を使わないこと(リプレイ・R.W.N.D.が再現できなくなる)。

export function nextRandom(world) {
  let t = (world.rngState = (world.rngState + 0x6d2b79f5) | 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randomRange(world, min, max) {
  return min + (max - min) * nextRandom(world);
}

export function randomInt(world, n) {
  return Math.floor(nextRandom(world) * n);
}
